import { EntitySwitch, isKind } from '@backstage/plugin-catalog';

import { apiPage } from '../apiPage';
import { componentPage } from '../componentPage';
import { defaultEntityPage } from '../defaultEntityPage';
import { domainPage } from '../domainPage';
import { groupPage } from '../groupPage';
import { systemPage } from '../systemPage';
import { userPage } from '../userPage';

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')}>
      {componentPage}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('api')}>{apiPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('group')}>{groupPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('user')}>{userPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('system')}>{systemPage} </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('domain')}>{domainPage}</EntitySwitch.Case>

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
